import React from 'react';
import ComponentHelper from '../../../supers/ComponentHelper';
import ListPanel from '../../../components/list-panel/ListPanel';
import { view, store } from 'react-easy-state';
import RESTService from '../../../services/RESTService';
import RoutingService from '../../../services/RoutingService';
import Spinner from '../../../components/spinner/Spinner';
import CommonService from '../../../services/CommonService';
import DialogModal from '../../../components/dialog-modal/DialogModal';
import ResolverModal from './resolver-modal/ResolverModal';
const connect = new RESTService();
const RS = new RoutingService();
const CS = new CommonService();
class ResolverList extends ComponentHelper {
	listData = store({
		searchText: '',
		modalTitle: 'Create New Resolver',
		loading: true,
		showDeleteModal: false,
		createOpen: false,
		resolvers: [],
		entities: [],
		entityMap: {},
		endpoints: [],
		mutators: [],
		mutatorMap: {}
	});
	formData = store({
		displayName: '',
		type: '',
		fieldType: 'string',
		fieldName: '',
		resolver: {
			type: 'field',
			endpoint: '',
			args: {}
		}
	});

	constructor(props) {
		super(props);
		this.isMutator = props.isMutator;
		this.autoBindAll(this, null, true);
	}

	closeCreate() {
		this.listData.createOpen = false;
		this.formData = store({
			displayName: '',
			type: '',
			fieldType: 'string',
			fieldName: '',
			resolver: {
				type: 'field',
				endpoint: '',
				args: {}
			}
		});
	}

	componentDidMount() {
		let p1 = connect
			.getEntities()
			.then(res => {
				this.listData.entities = res.data;
				this.listData.entityMap = CS.mapByParam('name', res.data);
			})
			.catch(err => {
				RS.smartError(err);
			});
		let p2 = connect
			.getEndpoints()
			.then(res => {
				this.listData.endpoints = res.data;
			})
			.catch(err => {
				RS.smartError(err);
			});
		let p3 = connect
			.getResolvers()
			.then(res => {
				this.listData.resolvers = res.data;
				this.listData.resolverMap = CS.mapByParam('name', res.data);
			})
			.catch(err => {
				RS.smartError(err);
			});
		let p4 = connect
			.getMutators()
			.then(res => {
				this.listData.mutators = res.data;
				this.listData.mutatorMap = CS.mapByParam('name', res.data);
			})
			.catch(err => {
				RS.smartError(err);
			});
		Promise.all([p1, p2, p3, p4]).then(() => {
			this.listData.loading = false;
		});
	}

	onSearchChange(evt) {
		this.listData.searchText = evt.target.value;
	}

	onEdit(evt) {
		let id = evt.target.dataset.id;
		if (id) {
			this.listData.toEdit = this.isMutator ? this.listData.mutatorMap[id] : this.listData.resolverMap[id];
			this.listData.modalTitle = this.isMutator ? 'Edit Mutator' : 'Edit Resolver';
			this.listData.createOpen = true;
		}
	}

	onDelete(evt) {
		let id = evt.target.dataset.id;
		if (id) {
			this.listData.toDelete = id;
			this.listData.showDeleteModal = true;
		}
	}

	toggleDeleteModal() {
		this.listData.showDeleteModal = !this.listData.showDeleteModal;
	}

	onConfirmDelete() {
		let deletePromise = null;
		if (this.isMutator) {
			let rs = this.listData.mutatorMap[this.listData.toDelete];
			if (rs) {
				deletePromise = connect.deleteMutator(rs.name);
			}
		} else {
			let rs = this.listData.resolverMap[this.listData.toDelete];
			if (rs) {
				deletePromise = connect.deleteResolver(rs.name);
			}
		}
		if (deletePromise) {
			deletePromise
				.then(() => {
					this.toggleDeleteModal();
					this.componentDidMount();
					RS.showSuccess();
				})
				.catch(err => {
					RS.smartError(err);
					this.toggleDeleteModal();
				});
		}
	}

	getEntityName(id) {
		if (this.listData.entityMap) {
			let e = this.listData.entityMap[id];
			if (e) {
				return e.displayName;
			}
		}
		return '';
	}

	buildResolverList() {
		if (this.listData.loading) {
			return <Spinner text="Loading..." />;
		}
		let res = this.isMutator ? this.listData.mutators : this.listData.resolvers;
		if (res.length <= 0) {
			return <div className="empty-list">Your environment has no {this.isMutator ? 'mutators' : 'resolvers'} yet.</div>;
		}
		let items = [];
		for (let i = 0; i < res.length; i++) {
			let rs = res[i];
			if (rs.displayName.indexOf(this.listData.searchText) >= 0) {
				items.push(
					<div className="list-item hbox vcenter" key={'list-item-' + rs.name} data-id={rs.name}>
						<div className="name grow-1 ellipse" title={rs.displayName}>
							{rs.displayName}
						</div>
						<div className="desc grow-1 ellipse" title={this.getEntityName(rs.type)}>
							{this.getEntityName(rs.type)}
						</div>
						<div className="desc grow-1" title={rs.resolver.endpoint}>
							{rs.resolver.endpoint}
						</div>
						<div className="actions hbox vcenter grow-1">
							<div className="action vbox hcenter vcenter" data-rh="Edit Resolver" data-rh-at="top" data-id={rs.name} onClick={this.onEdit}>
								<i className="mdi mdi-pencil" data-id={rs.name} />
							</div>
							<div className="action vbox hcenter vcenter" data-rh="Delete Resolver" data-rh-at="top" data-id={rs.name} onClick={this.onDelete}>
								<i className="mdi mdi-delete" data-id={rs.name} />
							</div>
						</div>
					</div>
				);
			}
		}
		return items;
	}

	onCreate() {
		this.listData.createOpen = true;
		this.listData.modalTitle = this.isMutator ? 'Create New Mutator' : 'Create New Resolver';
		this.listData.toEdit = null;
	}

	onResolverCreated() {
		this.listData.createOpen = false;
		this.listData.loading = true;
		this.listData.toEdit = null;
		this.componentDidMount();
	}

	render() {
		let { searchText, showDeleteModal, createOpen, entities, endpoints, modalTitle, toEdit } = this.listData;
		return (
			<div className="resolver-list-view animated fadeIn">
				<div className="resolver-list-header hbox vcenter hright">
					<div className="desc-text">
						{this.isMutator
							? 'Mutators are what allow you to manipulate and persist changes to your entities. They connect to your endpoints to communicate with your backend systems.'
							: 'Resolvers are what connect data sources to data models (Entities). They connect your endpoints and their arguments to the entities you have created and populate them with the data from your systems.'}
					</div>
					<div className="search-ctn hbox vcenter">
						<i className="mdi mdi-magnify" />
						<input
							className="search-input"
							value={searchText}
							onChange={this.onSearchChange}
							placeholder={`Search ${this.isMutator ? 'Mutators' : 'Resolvers'}...`}
						/>
					</div>
				</div>
				<ResolverModal
					isOpen={createOpen}
					isMutator={this.isMutator}
					formData={this.formData}
					title={modalTitle}
					entities={entities}
					endpoints={endpoints}
					editing={toEdit}
					onClose={this.closeCreate}
					onComplete={this.onResolverCreated}
				/>
				<ListPanel
					name={`${this.isMutator ? 'Mutator' : 'Resolver'} List`}
					className="resolver-list-cmp"
					labels={['name', 'entity', 'endpoint', 'actions']}
					onCreate={this.onCreate}
					listItems={this.buildResolverList()}
				/>
				<DialogModal
					isOpen={showDeleteModal}
					type="warning"
					showCancelButton={true}
					cancelBtnText="Cancel"
					confirmBtnText="Delete"
					text={`Deleting a ${this.isMutator ? 'mutator' : 'resolver'} cannot be undone`}
					title="Are you sure?"
					onConfirm={this.onConfirmDelete}
					onCancel={this.toggleDeleteModal}
				/>
			</div>
		);
	}
}

export default view(ResolverList);



// WEBPACK FOOTER //
// ./src/views/entities-panel/resolver-list/ResolverList.js